<template>
    <register-form></register-form>    
</template>
<script>
    import CoreLibrary from "@/core/helpers/CoreLibrary.js";
    import ThemeMixin from "@/core/mixins/global/ThemeMixin";
    import { FormMixin } from "@/core/mixins/form/FormMixin.js";
    import { ModalMixin } from "@/app/Mixins/ModalMixin";   
    export default {
        extends: CoreLibrary,
        name: "RegisterUserLayout",
        mixins: [FormMixin,ThemeMixin],
        data() {
            return {

            }
        },

    }
</script>